import gql from 'graphql-tag';

const query = gql`
  query DietSettings {
    me {
      id
      systemOfMeasures
      goalWeight {
        value
        unit
        __typename
      }
      diet {
        id
        mode
        __typename
      }
      lastMeasurement: measurement {
        weight(request: { limit: 1 }) {
          value
          unit
          __typename
        }
        __typename
      }
      firstMeasurement: measurement {
        weight(request: { limit: 1, order: asc }) {
          value
          unit
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export default query;
